export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl text-background-50 mb-4 block">
              51黑料吃瓜网
            </span>
            <p className="text-sm text-foreground-300 leading-relaxed">
              国内领先的在线吃瓜内容聚合平台。提供51吃瓜在线观看、51黑料在线观看、吃瓜在线视频、黑料在线播放等海量免费内容，高清流畅，无需下载。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              内容板块
            </h4>
            <div className="space-y-2">
              {['娱乐圈八卦', '网红黑料', '综艺内幕', '影视动态', '音乐圈瓜田', '直播圈风云', '社会热点'].map((item) => (
                <a
                  key={item}
                  href="#cards"
                  className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速导航
            </h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">网站首页</a>
              <a href="#about" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#updates" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
              <a href="#cards" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门黑料</a>
              <a href="#comments" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">吃瓜评论</a>
              <a href="#media" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">视频专区</a>
              <a href="#faq" className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 51黑料吃瓜网. 本站内容仅供娱乐参考，请理性吃瓜。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400">51黑料吃瓜网在线观看</span>
              <span className="text-xs text-foreground-400">51吃瓜在线观看</span>
              <span className="text-xs text-foreground-400">黑料吃瓜免费看</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}